import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SearchIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.529 10.434C14.5277 9.34835 14.0958 8.30754 13.3281 7.53986C12.5605 6.77219 11.5197 6.34032 10.434 6.339C9.34835 6.34032 8.30754 6.77219 7.53986 7.53986C6.77219 8.30754 6.34032 9.34835 6.339 10.434C6.34032 11.5197 6.77219 12.5605 7.53986 13.3281C8.30754 14.0958 9.34835 14.5277 10.434 14.529C11.5197 14.5277 12.5605 14.0958 13.3281 13.3281C14.0958 12.5605 14.5277 11.5197 14.529 10.434ZM19.209 18.039C19.209 18.679 18.679 19.209 18.039 19.209C17.728 19.209 17.426 19.081 17.216 18.861L14.081 15.735C13.1151 16.4004 11.9857 16.789 10.8149 16.8589C9.64414 16.9287 8.47654 16.677 7.43844 16.1312C6.40034 15.5853 5.53126 14.766 4.92521 13.7618C4.31916 12.7576 3.99922 11.6069 4 10.434C3.99974 9.589 4.16598 8.75223 4.48923 7.97151C4.81247 7.19078 5.28639 6.48139 5.88389 5.88389C6.4814 5.28639 7.19078 4.81247 7.97151 4.48922C8.75223 4.16598 9.589 3.99974 10.434 4C11.6067 3.99935 12.7573 4.31932 13.7613 4.92532C14.7653 5.53132 15.5845 6.40027 16.1304 7.4382C16.6762 8.47614 16.9279 9.64356 16.8582 10.8142C16.7885 11.9848 16.4001 13.1141 15.735 14.08L18.87 17.216C19.08 17.426 19.209 17.728 19.209 18.039Z'
                fill='currentColor'
            />
        </>
    ),
})

SearchIcon.displayName = 'SearchIcon'
